import React from 'react';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';
import { Comment } from 'ThreeTerminal_pc_dynamic';
import Footer from '@ifeng-fe/container_content/common/client/components/footer';

class EndPage extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        footer: PropTypes.object,
        recommendData: PropTypes.array,
    };

    state = {
        recommend: this.props.recommendData.slice(0, 6),
        arrNum: 2,
    };

    // recommendData去重分组
    getRecommend = (arrNum, recommendData) => {
        if (arrNum === 1) {
            this.setState({ recommend: recommendData.slice(0, 6) });
        } else if (arrNum === 2) {
            this.setState({ recommend: recommendData.slice(6, 12) });
        } else if (arrNum === 3) {
            this.setState({ recommend: recommendData.slice(12, 18) });
        }
    };

    // changeClick
    changeClick = () => {
        const { arrNum } = this.state;
        const { recommendData } = this.props;

        this.getRecommend(arrNum, recommendData);
        if (arrNum === 3) {
            this.setState({ arrNum: 1 });
        } else {
            this.setState({ arrNum: arrNum + 1 });
        }
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content, recommendData, footer } = this.props;
        const {
            allowComment,
            commentUrl,
            title,
            url,
            editorName,
            editorCode,
            skey,
            nextSlide,
            preSlide,
            columnData,
        } = content;
        const { recommend } = this.state;
        const { QRCode } = columnData;
        const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
        // const { docData, slideData } = content;
        const commentConfig = {
            // 文章单页的页面地址
            docUrl: commentUrl,
            // 文章的标题
            docTitle: title,
            // 文章评论的skey，这个是在后端生成好后给到前端的
            skey,
            // 兼容以后的专题评论
            speUrl: '',
            // 文章pc的页面地址
            pcUrl: url,
            // 获取评论内容接口
            cmtNumUrl: `//${ commentDomain }/get.php`,
            // 评论内容字数长度
            cmtLength: 1000,
            // 提交评论内容接口
            cmtPostUrl: `//${ commentDomain }/post.php`,
            // 最热评论数量
            hotLimit: 3,
            // 评论区域的高度限制
            limitHeight: '310px',
            // 推荐评论接口
            cmtVoteUrl: `//${ commentDomain }/vote.php`,
            // 现实回复的楼层
            replyLimit: 5,
            // 举报提交接口
            jubUrl: `//${ commentDomain }/report`,
            // 举报次数，便于每次回调函数名不同
            jubNum: 0,
            // 是否是评论详情页面
            isComment: false,
            // 是否允许评论
            allowComment,
        };

        return (
            <div className={styles.end_page}>
                <div className={styles.top_part}>
                    <div className={styles.all_end_container}>
                        <div className={styles.left_repeat}>
                            <a href={url} className={styles.review}>
                                <div className={styles.end_title}>图集浏览结束，重新浏览</div>
                            </a>
                            <div className={styles.erweima_end}>
                                <img src={QRCode} alt={columnData.title} />
                            </div>
                        </div>

                        <div className={styles.right_imgs}>
                            <div className={styles.clearfl}>
                                {/* <div className={styles.tjTitle}>推荐图集</div> */}
                                <div className={styles.tjTitle}>热门推荐</div>
                                {recommendData.length > 12 ? (
                                    <div className={styles.anotherTj} onClick={this.changeClick}>
                                        换一组
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>

                            {/* tuijian */}
                            {recommend.length > 0
                                ? recommend.map((item, index) => (
                                      <a href={item.url} target="_blank" key={index}>
                                          <div
                                              className={
                                                  index % 2 !== 0 ? styles.imgs_containerR : styles.imgs_containerL
                                              }>
                                              <div className={styles.imgs}>
                                                  <img src={item.thumbnail} alt={item.title} />
                                              </div>
                                              <div className={styles.imgs_content} title={item.title}>
                                                  {item.title}
                                              </div>
                                          </div>
                                      </a>
                                  ))
                                : ''}
                        </div>

                        <div className={styles.prev_article}>
                            <a href={preSlide ? preSlide.url : ''} target="_blank">
                                <img
                                    src="//p0.ifengimg.com/fe/news_zairenjian_homepage/images/prev_img_c4003f7d.png"
                                    alt=""
                                />
                            </a>
                        </div>

                        <div className={styles.next_article}>
                            <a href={nextSlide ? nextSlide.url : ''} target="_blank">
                                <img
                                    src="//p0.ifengimg.com/fe/news_zairenjian_homepage/images/next_img_ef8baa76.png"
                                    alt=""
                                />
                            </a>
                        </div>
                    </div>
                </div>

                {/* 评论 */}
                <div className={styles.cmtContainer}>
                    <LazyLoad>
                        <Comment articleInfo={commentConfig} />
                    </LazyLoad>
                </div>

                {/* footer */}
                <div className={styles.footer}>
                    <Footer content={footer} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(EndPage);
